import { useMemo } from "react";
import { useGetBulkDisbursementStatusFilters } from "../../../hooks/queries/useBulkUploadsQueries";
import { BULK_UPLOAD_STATUS_VALUE_BY_LABEL } from "../constants/bulkUploadsConstants";

export const useBulkUploadStatusOptions = () => {
  const {
    data: labels = [],
    isLoading,
    isError,
  } = useGetBulkDisbursementStatusFilters();

  const options = useMemo(() => {
    return labels
      .map((label) => {
        const value = BULK_UPLOAD_STATUS_VALUE_BY_LABEL[label];
        if (!value) return null;
        return { value, label };
      })
      .filter(Boolean);
  }, [labels]);

  const optionsWithAll = useMemo(
    () => [{ value: "all", label: "All Statuses" }, ...options],
    [options],
  );

  return {
    options,
    optionsWithAll,
    isLoading,
    isError,
    hasOptions: options.length > 0,
  };
};

export default useBulkUploadStatusOptions;
